import React from 'react';
import {Dropdown,DropdownMenu , DropdownToggle,FormGroup,FormFeedback, Label,DropdownItem  } from 'reactstrap';
import $ from 'jquery';

class ValidatedDropDown extends React.Component {
    constructor(props) 
    {
        super(props);
        this.toggleDocTypeDd = this.toggleDocTypeDd.bind(this);
        this.validate = this.validate.bind(this);
        this.changeValue =this.changeValue.bind(this);
        this.state = 
        {
            valid : Boolean,
            errorMessage: "",
            inputCls: 'is-invalid',
            docTypedropdownOpen: false,
            dropDownValue : "",
            dropDownText : "Document Type",
            dropDownData : {},
            //documentTypes: [],
            ...props
        };

        this.setState({ valid: false, errorMessage : "Please enter a valid value." })
    }

    componentDidUpdate(prevProps){
        if(this.props.documentTypes !== prevProps.documentTypes)
            this.setState({
                documentTypes: this.props.documentTypes
            })
    }

    toggleDocTypeDd() {
        this.setState(prevState => ({
          docTypedropdownOpen: !prevState.docTypedropdownOpen
        }));
      }

    validate(inputValue)
    {
        if(this.props.mandatory)
        {
            if(inputValue)
            {
                this.setState({ inputCls: 'is-valid', valid: false,errorMessage : ""})
                return true;
            }
            else
            {
                this.setState({ inputCls: 'is-invalid', valid:true ,errorMessage : "Please enter a valid value"})
                return false;
            }
        }
        else
        {
            this.setState({ inputCls: 'is-valid', valid: false,errorMessage : ""})
            return true;
        }
    }

    changeValue(e) 
    {
      this.setState(
      {
          dropDownValue: e.currentTarget.id , 
          dropDownText : e.currentTarget.textContent , 
          documentTypeConfig : this.state.documentTypes[e.currentTarget.id]
      });

        //validate the selection 
        if(this.validate(e.currentTarget.id))
        {
            //ripple up the change 
            this.props.onChange(e);
        }
    }
    
    render() 
    {
        var style = {};
        style.display = 'none';

        const dropdownitems = [];
  
        var local = 'en'; //todo change the localization
  
        if(this.state.documentTypes !== undefined && this.state.documentTypes.length !== 0)
        {
          this.state.documentTypes.forEach
          (
            (documentType,i) => 
            {
              dropdownitems.push(<DropdownItem onClick={this.changeValue} id={i} data={JSON.stringify(documentType)}>{documentType.Description[local]}</DropdownItem>);
            }
          );
        }

        return (<FormGroup>
            <Label>{this.props.labelText}</Label>
            <Dropdown  isOpen={this.state.docTypedropdownOpen} toggle={this.toggleDocTypeDd}>
                <DropdownToggle className={this.state.inputCls} id={this.props.id} value={this.state.dropDownValue} data={this.state.dropDownData} caret>
                {this.state.dropDownText}
                </DropdownToggle>
                <DropdownMenu>
                  {dropdownitems}
                </DropdownMenu>
              </Dropdown>
              <FormFeedback visible={!!this.state.valid}>{this.state.errorMessage}</FormFeedback>
          </FormGroup>);
    
        //return (<FormGroup>
        //    <Label>{this.props.labelText}</Label>
        //    <Input className={this.state.inputCls}  onBlur={this.onchange}></Input>
        //    <FormFeedback visible={!!this.state.valid}>{this.state.errorMessage}</FormFeedback>
        //</FormGroup>);  
    }
};

export default ValidatedDropDown; 